export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4809.f49410f6.jpg";